export enum FormType {
    BOTS,
    CONFIG,
    FLAGS,
    PROMPTS,
    HOURS,
    HOURS_EVENTS,
    HOLIDAYS,
    MULTISELECT_FLAGS,
    MULTISELECT_HOURS,
    MULTISELECT_PROMPTS,
    MULTISELECT_CONFIG
}